import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "action-menu",
  "use": "action-menu-usage",
  "viewBox": "0 0 5 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 23\" id=\"action-menu\"><circle cx=\"2.5\" cy=\"4.5\" r=\"2.5\" /><circle cx=\"2.5\" cy=\"11.5\" r=\"2.5\" /><circle cx=\"2.5\" cy=\"18.5\" r=\"2.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol